var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.47505 9.463C2.35904 6.29213 4.83053 3.6252 8.00105 3.5C11.1716 3.6252 13.6431 6.29213 13.527 9.463C13.527 10.78 14.958 12.063 15 13.383C15 13.4017 15 13.4203 15 13.439C15.031 14.2847 14.3717 14.9959 13.526 15.029H10.334C10.337 15.677 10.0928 16.3018 9.65105 16.776C9.22635 17.2372 8.62801 17.4996 8.00105 17.4996C7.37409 17.4996 6.77575 17.2372 6.35105 16.776C5.90934 16.3018 5.66508 15.677 5.66805 15.029H2.47505C1.62942 14.9959 0.970079 14.2847 1.00105 13.439C1.00105 13.4203 1.00105 13.4017 1.00105 13.383C1.04405 12.067 2.47505 10.781 2.47505 9.463Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-11",
    d: "M5.66797 14.279C5.25376 14.279 4.91797 14.6148 4.91797 15.029C4.91797 15.4432 5.25376 15.779 5.66797 15.779V14.279ZM10.334 15.779C10.7482 15.779 11.084 15.4432 11.084 15.029C11.084 14.6148 10.7482 14.279 10.334 14.279V15.779ZM9.00097 2.25C9.41518 2.25 9.75097 1.91421 9.75097 1.5C9.75097 1.08579 9.41518 0.75 9.00097 0.75V2.25ZM7.00097 0.75C6.58676 0.75 6.25097 1.08579 6.25097 1.5C6.25097 1.91421 6.58676 2.25 7.00097 2.25V0.75ZM5.66797 15.779H10.334V14.279H5.66797V15.779ZM9.00097 0.75H7.00097V2.25H9.00097V0.75Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.c5be33e7eaebe8e7262dedf4bb1f59d5.svg";
export { ForwardRef as ReactComponent };